import { useTranslation } from 'react-i18next';
import { EmptyState } from '../../base/EmptyState';
import { Spinner } from '../../base/Spinner';
import { FileItem, type FileItemData } from '../FileItem';
import styles from './FileList.module.css';

interface FileListProps {
  files: FileItemData[];
  isLoading?: boolean;
  isRefetching?: boolean;
  error?: string | null;
  emptyTitle?: string;
  emptyDescription?: string;
  onFilePress?: (file: FileItemData) => void;
  onMenuPress?: (file: FileItemData) => void;
}

export const FileList = ({
  files,
  isLoading = false,
  error = null,
  emptyTitle = 'No files yet',
  emptyDescription = 'Save your first file to get started',
  onFilePress,
  onMenuPress,
}: FileListProps) => {
  const { t } = useTranslation();

  if (isLoading && files.length === 0) {
    return (
      <div className={styles.loading}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (error && files.length === 0) {
    return (
      <EmptyState
        title={t('files.errorLoading', 'Error loading files')}
        description={error}
      />
    );
  }

  if (files.length === 0) {
    return (
      <EmptyState
        title={emptyTitle}
        description={emptyDescription}
      />
    );
  }

  return (
    <div className={styles.container}>
      {files.map((file) => (
        <FileItem
          key={file.id}
          file={file}
          onPress={onFilePress}
          onMenuPress={onMenuPress}
        />
      ))}
    </div>
  );
};
